import { Controller } from "@hotwired/stimulus"

const REDIRECT_DELAY_MS = 2000

export default class ReturnToStoreController extends Controller {
  static values = { url: String }

  connect() {
    this.timer = setTimeout(() => this.go(), REDIRECT_DELAY_MS)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  go(event) {
    event?.preventDefault()
    clearTimeout(this.timer)
    try {
      window.top.location.href = this.urlValue
    } catch (error) {
      window.location.href = this.urlValue
    }
  }
}
